module.exports = __webpack_public_path__ + "r-v3/img/ml_12_01.b47c14ee.jpg";